import React from 'react';
import Moment from 'moment';
import { InlineSVG } from '.';

const Date = (props) => {
  const format = props.hasTime ? "DD/MM/YYYY [às] HH:mm" : "DD/MM/YYYY" ;
  return (
    <span className="date">
      <InlineSVG src={require('../img/icon-calendar.svg')} />
      {Moment(props.date).utc().format(format)}
    </span>
  )
};

export default Date;



// WEBPACK FOOTER //
// ./src/components/Date.js